import { Request, Response } from "express"

import { getUser } from "#services/user/login"

export const login = async (req: Request, res: Response) => {
	const user = await getUser({
		email: req.body.email,
		password: req.body.password,
	})

	if (user === null) {
		res.status(500).send("User not found, or authentication information invalid")
	} else {
		res.json(user)
	}
}
